import React, { useState, useEffect } from "react";
import { FaStream, FaRegEdit, FaAngleRight } from "react-icons/fa";
import ProjectsChart from "./ProjectsChart";
import BarChart from "./BarChart";
import axios from "axios";
import Cookies from "universal-cookie";
import { FaTimesCircle } from "react-icons/fa";
import { SpinnerCircular } from "spinners-react";

require("../../assets/stylesheets/Admin/Admin.css");

const cookie = new Cookies();

function Admin() {
  const [loading, handleLoading] = useState(true);

  const [activateItem, setActivateItem] = useState("");
  const [sortedProjects, setSortedProjects] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [sortedExProjects, setSortedExProjects] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalExProjects, setTotalExProjects] = useState(0);

  const [projectsTop, setProjectsTop] = useState([]);
  const [categories, setCategories] = useState([]);

  const [winnersPanel, setWinnersPanel] = useState(false);
  const [dataWinners, setDataWinners] = useState([]);

  const visiblePanelTrue = (id) => {
    setWinnersPanel(true);
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/projects/getwinners",
        { id }
      )
      .then((res) => {
        console.log(res.data);
        setDataWinners(res.data);
        handleLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const visiblePanelFalse = () => {
    setWinnersPanel(false);
    setDataWinners([]);
  };

  const WinnersPanel = () => {
    return (
      <div className="qualifyPanel">
        <span
          onClick={() => {
            visiblePanelFalse();
          }}
        >
          <FaTimesCircle />{" "}
        </span>
        {loading && <SpinnerCircular secondaryColor="rgb(237, 237, 237)" />}
        {dataWinners.length > 0 && (
          <div className="top">
            <div>
              <div className="category">
                <h2>{dataWinners[0].title}</h2>
                <img
                  src={require(`../../assets/images/firstPlace.jpeg`)}
                  alt={`${dataWinners.title}`}
                />
                <div className="informationB">
                  <p>Coordinado por:</p>
                  <h5>{dataWinners[0].coordinator}</h5>
                  <h5>
                    <b>
                      Promedio:{" "}
                      {(
                        dataWinners[0].netRating / dataWinners[0].judges.length
                      ).toFixed(2)}
                      %
                    </b>
                  </h5>
                </div>
              </div>
            </div>

            <div>
              <div className="category">
                <h2>{dataWinners[1].title}</h2>
                <img
                  src={require(`../../assets/images/secondPlace.jpeg`)}
                  alt={`${dataWinners.title}`}
                />
                <div className="informationB">
                  <p>Coordinado por:</p>
                  <h5>{dataWinners[1].coordinator}</h5>
                  <h5>
                    <b>
                      Promedio:{" "}
                      {(
                        dataWinners[1].netRating / dataWinners[1].judges.length
                      ).toFixed(2)}
                      %
                    </b>
                  </h5>
                </div>
              </div>
            </div>

            <div>
              <div className="category">
                <h2>{dataWinners[2].title}</h2>
                <img
                  src={require(`../../assets/images/thirdPlace.jpeg`)}
                  alt={`${dataWinners.title}`}
                />
                <div className="informationB">
                  <p>Coordinado por:</p>
                  <h5>{dataWinners[2].coordinator}</h5>
                  <h5>
                    <b>
                      Promedio:{" "}
                      {(
                        dataWinners[2].netRating / dataWinners[2].judges.length
                      ).toFixed(2)}
                      %
                    </b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleCounterProject = async () => {
    await axios
      .get(
        "https://ferias-ingenio-backend.vercel.app/api/projects/getcountprojects"
      )
      .then((res) => {
        var j = 0;
        var t = 0;
        for (let i of res.data) {
          sortedProjects[j] = i.count;
          t += i.count;
          j++;
        }
        setTotalProjects(t);
      })
      .catch((err) => {
        console.log(err);
      });

    await axios
      .get(
        "https://ferias-ingenio-backend.vercel.app/api/projects/getcountexprojects"
      )
      .then((res) => {
        var j = 0;
        var t = 0;
        for (let i of res.data) {
          sortedExProjects[j] = i.count;
          t += i.count;
          j++;
        }
        setTotalExProjects(t);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleGetProject = async () => {
    await axios
      .get(
        "https://ferias-ingenio-backend.vercel.app/api/projects/gettopprojects"
      )
      .then((res) => {
        console.log(res.data);
        setProjectsTop(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    await axios
      .get(
        "https://ferias-ingenio-backend.vercel.app/api/categories/getcategories"
      )
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        if (err) console.log(err);
      });
  };

  const NavbarSide = () => {
    const [menu, setMenuVisibility] = useState(true);

    useEffect(() => {}, [menu, totalProjects]);

    const logout = () => {
      cookie.remove("id", { path: "/" });
      cookie.remove("username", { path: "/" });
      cookie.remove("email", { path: "/" });
      cookie.remove("likes", { path: "/" });
      cookie.remove("level", { path: "/" });
      cookie.remove("judge", { path: "/" });
      cookie.remove("admin", { path: "/" });
      cookie.remove("photo", { path: "/" });
      window.open(
        "https://ferias-ingenio-backend.vercel.app/api/auth/logout",
        "_self"
      );
    };

    const handleSideBar = () => {
      setMenuVisibility((current) => !current);
    };

    const handleActivateState = async (id) => {
      setActivateItem(id);
      //   loading = true;
    };

    return (
      <div className={menu ? `navbar-side-extended` : `navbar-side`}>
        <div className="btn-sidebar" onClick={handleSideBar}>
          <FaStream />
        </div>
        <div className="campSection">
          <div className="options-categories">
            <div className="summary">
              <FaRegEdit /> Menu
            </div>
            <a
              onClick={() => {
                handleActivateState("dashboard");
                handleCounterProject();
              }}
            >
              <div
                className={
                  activateItem == "dashboard"
                    ? `summary-item-activated`
                    : `summary-item`
                }
              >
                <FaAngleRight /> Dashboard
              </div>
            </a>

            <a onClick={() => handleActivateState("users")}>
              <div
                className={
                  activateItem == "users"
                    ? `summary-item-activated`
                    : `summary-item`
                }
              >
                <FaAngleRight /> Usuarios
              </div>
            </a>

            <a
              onClick={() => {
                handleActivateState("projects");
                handleGetProject();
              }}
            >
              <div
                className={
                  activateItem == "projects"
                    ? `summary-item-activated`
                    : `summary-item`
                }
              >
                <FaAngleRight /> Proyectos
              </div>
            </a>

            <a onClick={() => handleActivateState("settings")}>
              <div
                className={
                  activateItem == "settings"
                    ? `summary-item-activated`
                    : `summary-item`
                }
              >
                <FaAngleRight /> Ajustes
              </div>
            </a>
          </div>

          <div className="botSection">
            <a href="/categories">
            <div className="logout-btn" title="Ir a inicio">
              Inicio
            </div>
            </a>

            <div className="logout-btn" onClick={logout} title="Cerrar Sesión">
              Salir
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ContentPanel = () => {
    const [content, setContent] = useState({
      username: "",
      password: "",
    });

    const saveJudge = () => {
      axios
        .post(
          "https://ferias-ingenio-backend.vercel.app/api/users/addjudge",
          content
        )
        .then((res) => {})
        .catch((err) => {
          if (err) console.log(err);
        });
    };

    return (
      <div className="contentPanel">
        {activateItem == "dashboard" && (
          <div className="dashboard">
            <FaAngleRight /> Proyectos{" "}
            <button
              onClick={() => {
                handleCounterProject();
              }}
            >
              Refrescar
            </button>
            <ProjectsChart
              sortedProjects={sortedProjects}
              total={totalProjects}
            />
            <FaAngleRight /> Descripción
            <BarChart
              exProjects={sortedExProjects}
              coProjects={sortedProjects}
              totalCo={totalProjects}
              totalEx={totalExProjects}
            />
          </div>
        )}

        {activateItem == "users" && <div className="users"></div>}

        {activateItem == "projects" && (
          <div>
            <p>
              <FaAngleRight /> Ganadores por categoría
            </p>
            <div className="projects">
              {Object.values(categories).map((cat) => {
                let img = require(`../../assets/images/categories/${cat.title}.png`);
                return (
                  <a
                    key={cat.id}
                    onClick={() => {
                      visiblePanelTrue(cat.id);
                    }}
                  >
                    <div className="category">
                      <img src={img} alt={`${cat.title}`} />
                      <div className="information">
                        <p>Ganadores de categoría de</p>
                        <h5>{cat.name}</h5>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
            <p>
              <FaAngleRight /> Top 3
            </p>
            {projectsTop.length > 0 && (
              <div className="top">
                <div>
                  <div className="category">
                    <h2>{projectsTop[0].title}</h2>
                    <img
                      src={require(`../../assets/images/firstPlace.jpeg`)}
                      alt={`${projectsTop.title}`}
                    />
                    <div className="informationB">
                      <p>coordinado por:</p>
                      <h5>{projectsTop[0].coordinator}</h5>
                      <h5>con {projectsTop[0].likes} votos</h5>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="category">
                    <h2>{projectsTop[1].title}</h2>
                    <img
                      src={require(`../../assets/images/secondPlace.jpeg`)}
                      alt={`${projectsTop.title}`}
                    />
                    <div className="informationB">
                      <p>coordinado por:</p>
                      <h5>{projectsTop[1].coordinator}</h5>
                      <h5>con {projectsTop[1].likes} votos</h5>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="category">
                    <h2>{projectsTop[2].title}</h2>
                    <img
                      src={require(`../../assets/images/thirdPlace.jpeg`)}
                      alt={`${projectsTop.title}`}
                    />
                    <div className="informationB">
                      <p>coordinado por:</p>
                      <h5>{projectsTop[2].coordinator}</h5>
                      <h5>con {projectsTop[2].likes} votos</h5>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activateItem == "settings" && (
          <div className="settings">
            <input
              type="text"
              placeholder="Username"
              value={content.username}
              onChange={(e) => {
                setContent({ ...content, username: e.target.value });
              }}
            />
            <input
              type="text"
              placeholder="pass"
              value={content.password}
              onChange={(e) => {
                setContent({ ...content, password: e.target.value });
              }}
            />
            <button onClick={saveJudge}>Enviar</button>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="PanelJudge">
      <NavbarSide />
      {winnersPanel && <WinnersPanel />}
      <ContentPanel />
    </div>
  );
}

export default Admin;
